import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import FormGenerator from './FormGenerator';
import InquiryService from "../../services/inquiryService";
import CircularProgress from '@mui/material/CircularProgress';
import CandidateService from "../../services/candidateService";
import Card from '@mui/material/Card';
import FileCards from "./FileCard"


const theme = createTheme({
  typography: {
    fontSize: 10, // Adjust the default font size
  },
  components: {
    // Customize the component sizes
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the button font size
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the text field font size
          height: 30, // Adjust the text field height
          size: "small", // Adjust the text field height
          boxSizing: "inherit", // Adjust the text field height
        },
      },
    },
    // Add other components here with their desired customizations
  },
});


export const fieldData = [
    {
      "type": "TextField",
      "name": "nic",
      "label": "NIC",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "regNumber",
      "label": "Reg Number",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "passportNo",
      "label": "Passport Number",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "name",
      "label": "Full Name",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "phone1",
      "label": "Phone 1",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
        "type": "TextField",
        "name": "phone2",
        "label": "Phone 2",
        "size": "small",
        "required": true,
        "fullWidth": true
      },
    {
      "type": "TextField",
      "name": "address",
      "label": "Address",
      "size": "small",
      "required": true,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "age",
      "label": "Age",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type":"TextField",
      "name":"foreignClient",
      "label":"Foreign Client",
      "size":"small",
      "required":false,
      "fullWidth":true
    },
    {
      "type": "TextField",
      "name": "appliedPosition1",
      "label": "Applied Position 1",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
      "type": "TextField",
      "name": "appliedPosition2",
      "label": "Applied Position2",
      "size": "small",
      "required": false,
      "fullWidth": true
    },
    {
        "type": "TextField",
        "name": "appliedPosition3",
        "label": "Applied Position3",
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "TextField",
        "name": "country",
        "label": "Country",
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "Select",
        "name": "gender",
        "label": "Gender",
        "options": [
            {'label':'Male','value':'male'},
            {'label':'Female','value':'Female'}
        ],
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "Select",
        "name": "paymentStatus",
        "label": "Payment Status",
        "options": [
            {'label':'Paid','value':'Paid'},
            {'label':'Not Paid','value':'Not Paid'},
            {'label':'Waived Off','value':'Waived Off'},
            {'label':'Partially Paid','value':'Partially Paid'}
        ],
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "Select",
        "name": "paymentMethod",
        "label": "Payment Method",
        "options": [
            {'label':'Over the counter','value':'OTC'},
            {'label':'POS','value':'POS'},
            {'label':'CDM','value':'CDM'},
            {'label':'Bank Transfer','value':'Bank Transfer'}
        ],
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "TextField",
        "name": "paymentDate",
        "inputType": "date",
        "label": "Payment Date",
        "size": "small",
        "required": false,
        "fullWidth": true
      },
      {
        "type": "TextField",
        "name": "interviewDate",
        "inputType": "date",
        "label": "Interview Date",
        "size": "small",
        "required": false,
        "fullWidth": true
      }, 
      {
        "type": "Select",
        "name": "interviewVenue",
        "label": "Interview Mode",
        "options": [
            {'label':'Virtual','value':'Virtual'},
            {'label':'Physical','value':'Physical'},
        ],
        "size": "small",
        "required": false,
        "fullWidth": true
      },
]

const InquiryForm = (props) => {

   
  const [loading, setLoading] = useState(false); 
  const [inquiry, setInquiry] = useState({});

 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setInquiry((prevState) => ({
        ...prevState,
        [name]: fieldValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Perform form submission logic or API request with jobOrder data
    
   
   InquiryService.createInquiry(inquiry).then((response) => {
      console.log(response);
      setLoading(false);
      props.handleClose()
    }).catch((error) => {
      console.log(error);
      setLoading(false);
      
    });
  };

  const handleOnClose = () => {
    props.handleClose()
  };


  
  
   
 

  const [formFields, setFormFields] = useState([])
  const [search, setSearch] = useState('')
  const [files, setFiles] = useState([])

  const getNewFile = async (nic) => {
    try {
      const res = await CandidateService.getNewFiles(nic,'paymentSlip');
      console.log(res.data)
      if(res?.data?.length >0){
        setFiles(res.data);
      }else{
        setFiles([])
      }

    } catch (error) {
      alert("Error getting files");
    }
  };
  const handleSearch =  (nic) => {
    try {
     InquiryService.getInquiryByNIC(nic).then((res) => {
      if(res?.data?.length >0){
        console.log(res.data[0])
        setInquiry(res.data[0]);
        getNewFile(nic);
        }else{
          alert("This nic is not registered!")
          setFiles([])
        }
      })
    } catch (error) {
      alert("Error creating inquiry");
    }
  };

  const [file, setFile] = useState(null);
 
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const [fileName, setFileName] = useState(null);

  const uploadFile = (file) => {
    //shpw alert to input file name
    const fileName = prompt("Enter file name");
    //remove spaces
    const name = fileName.replace(/\s/g, '');
    //set file name
    const formData = new FormData();
    const extraField={
      "paymentStatus": inquiry.paymentStatus,
      "name":name
    }
    formData.append("file", file);
    formData.append("regNumber", inquiry.regNumber)
    formData.append("nic", inquiry.nic)
    formData.append("fileName",name)
    formData.append("ent","paymentSlip")
    formData.append("extraField",JSON.stringify(extraField))
    CandidateService.uploadNewFile(formData).then((res) => {
      alert("File uploaded successfully");
      handleSearch(inquiry.nic)
    }).catch((err) => {
      alert("Error uploading file");
    });
  };

  useEffect(() => {
    //remove spaces from nic and regNumber
    const nic = inquiry.nic?.replace(/\s/g, '');
    const regNumber = inquiry.regNumber?.replace(/\s/g, '');
    setInquiry((prevState) => ({
      ...prevState,
      nic: nic,
      regNumber: regNumber
  }));
  }, [inquiry.nic,inquiry.regNumber]);
  
  const handleUpdate = (data,id) =>{
    
    try {
       InquiryService.updateInquiry(inquiry,inquiry.id).then((res) => {
       console.log("Hi",res.data)
       alert("Updated inquiry");
       handleSearch(inquiry.nic)
       }).catch((err) => {
        console.log(err)
        alert("Error updating inquiry");
        })
     } catch (error) {
       alert("Error creating inquiry");
     }
  }

  return (
  <ThemeProvider theme={theme}>
    <form style={{
      backgroundColor: 'white',
      padding: 10,
      borderRadius: 10,
    }} onSubmit={handleSubmit}>
    <Grid container spacing={3}>
    <Grid item xs={6}>
        <TextField
         name="search"
          label="Search by Reg number"
          variant="outlined"
          size="small"
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
        />
        </Grid>
        <Grid item xs={6}>
        <Button
          disabled={loading}
          fullWidth
          onClick={() => handleSearch(search)}
          variant="contained" color="primary">
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </Button>
        </Grid>
        <Grid item xs={12}>
       
        <FormGenerator formData={inquiry} handleChange={handleChange} fields={fieldData} />

        <Card style={{
          padding: 10,
          margin: 10,
        }}>
        <input             
        disabled={!(inquiry.name && inquiry.nic)}
        type="file" onChange={handleFileChange} />
        <Button
        disabled={!(inquiry.name && inquiry.nic)}
        onClick={() => uploadFile(file)}
        variant="contained" color="primary">
          Upload
        </Button>
        </Card>
      <FileCards files={files} />

    </Grid>
       <Grid item xs={12}>
       
        </Grid>
        <Grid item xs={12}>
        <Button
          disabled={loading}
          type="submit" variant="contained" color="primary">
            {loading ? <CircularProgress size={24} /> : 'Submit'}
        </Button>

        <Button 
        disabled={loading}
        onClick={handleUpdate} variant="contained" color="secondary">Update</Button>
        </Grid>
    </Grid>
    </form>
  </ThemeProvider>
  );
};

export default InquiryForm;